import { OKSign, STATUS_CODE } from '@/domains/CommonDomain'
import { IPayAction } from '@/modules/version/V2/bill-payment/BillPaymentResultModule'

export const BillHistoryRowCount = 50

export const PAYMENT_TYPE_CODE = {
  PULSA: '01',
  TOPUP: '02',
  BILLS: '03',
}

export const BILLS_PRODUCT_GROUP_TYPE_CODE = {
  // Bills Payment Type
  PHONE_BILL: '01',
  PULSA_POSTPAID: '0301',
  PLN: '0302',
  TELKOM: '0303',
  UTILITIES: '0304',
  INTERNET: '0305',
  CREDITCARD: '0306',
  TICKET: '0307',
  FINANCE: '0308',
  INSURANCE: '0309',
  ZAKAT: '0310',
  OTHERS: '0311',
  HANABANK_VIRTUAL_ACCOUNT: '0312',

  // PULSA Payment Type
  TELKOMSEL: '11',
  INDOSAT: '12',
  THREE: '13',
  XL: '14',

  // TOP UP Payment Type
  STARBUCKS: '31101',
}

export const BILLS_IDENTIFIER_TYPE_CODE = {
  // IDENTIFIER_TYPE_CODE
  PHONE: 'PHONE_NUM',
  CREDITCARD: 'CARD_NUM',

  CUSTOMERID: 'CUSTOMER_ID',
  AACTSHF: 'ACCT_SHF',

  VA: 'VA',
}

export const BILLS_PLN_PRODUCT_TYPE_CODE = {
  PLN_PREPAID: '29001',
  PLN_POSTPAID: '29002',
}

export const HANABANK_VIRTUAL_ACCOUNT_PRODUCT_TYPE_CODE = {
  HANABANK_VIRTUAL_ACCOUNT: '20001',
}

export const BILLS_FORCE_ERROR_CODE = {
  WRONG_PHONE_NUMBER: 'wrongPhoneNumber',
}

export const EmptyPaymentType: IPaymentType = {
  code: '',
  name: '',
  productGroupList: [],
}

export const EmptyProductGroupType: IProductGroupType = {
  code: '',
  name: '',
  initial: '',
  color: '',
  productTypeList: [],
}

export const EmptyProductType: IProductType = {
  identifierName: '',
  identifierType: '',
  redoYn: '',
  code: '',
  name: '',
  switchId: '',
  isAutoFilled: false,
  voucherList: [],
  transactionFee: '0',
  appsBillType: '',
  qcPayable: true,
}

export const EmptyBill: IBillPaymentInquireResponse = {
  amount: '0',
  customerId: '',
  customerName: '',
  reserved: '',
  fee: '',
  billNum: '',
  tariff: '',
  meterNo: '',

  ticketInfo1: '',
  ticketInfo2: '',
  ticketInfo3: '',
  ticketInfo4: '',
}

export const EmptyBillPaymentPayResponse: IBillPaymentPayResponse = {
  acctNo: '',
  acctCurJan: '',
  custName: '',
  acctTitle: '',
  hisNo: '',
  customerId: '',
  favorite: false,
  fee: '',
  tselSerialNum: '',
  paidAmount: '',
  paidDate: 0,
  productTypeCode: '',
  trxPayKey: 0,
  refNo: '',
  plnToken: '',
  ticketInfo1: '',
  ticketInfo2: '',
  ticketInfo3: '',
}

export const EmptyBillPaymentPayInfo: IPayAction = {
  amount: '',
  fee: '',
  customerId: '',
  reserved: '',
  productTypeCode: '',
  isDisbursal: OKSign.NO,
  loanAcctNo: '',
  loanAmt: '',
  disburseFee: '',
  unSoldTokenYn: '',
}

export const EmptyBillPaymentRecentAndFavorite: IBillPaymentRecentAndFavorite = {
  acctNo: '',
  customerId: '',
  favorite: false,
  lastUpdatedDate: 0,
  productTypeCode: '',
  productTypeName: '',
  productTypeSwitchId: '',
  trxPayKey: 0,
}

export interface IBillPaymentResultIdentity {
  productTypeCode: string
}

export interface IBillPaymentProductGroupIdentity {
  paymentTypeCode: string
}

export interface IBillPaymentProductIdentity {
  paymentTypeCode: string
  productGroupTypeCode: string
  customerId?: string
}

export interface IBillPaymentAmountIdentity {
  productTypeCode: string
  customerId: string
}

export interface IBillPaymentInquireRequest {
  amount?: string // 지불금액
  fee?: string // 수수료
  customerId: string // 고객번호
  customerName?: string // 고객명
  productTypeCode: string // ProductType’s code
  productTypeSwitchId: string // ProductType’s switchId
  identifierType?: string // identifierType
  reserved?: string // 하나은행쪽 예약값
  ticketInfo1?: string
  ticketInfo2?: string
  ticketInfo3?: string
  ticketInfo4?: string
  merchantName?: string
  isDisbursal?: string
  lonAcctNo?: string
}

export interface IBillPaymentInquireResponse {
  amount: string // 결제금액
  customerId: string // 고객번호
  customerName: string // 고객이름
  reserved: string // 하나은행쪽 예약값
  fee: string
  billNum: string
  tariff: string
  meterNo: string
  ticketInfo1?: string
  ticketInfo2?: string
  ticketInfo3?: string
  ticketInfo4?: string
  merchantName?: string
  restQuota?: number
  totQuota?: number
  disburseFee?: number
  unSoldTokens?: string[]
  /**
   * Number of unpaid PLN bill months
   */
  totLbrTgh?: string
  /**
   * List of unpaid PLN bill months
   */
  blTh?: string
}

export interface IBillPaymentMaxResponse {
  maxAmountFlag: boolean
}

export interface IBillFormState {
  acctNo: string // 지불 계좌번호
  amount: string // 결제금액
  fee: string // 수수료
  customerId: string // 고객번호
  customerName: string
  reserved: string // 하나은행쪽 예약값
}

export interface IBillPaymentPayRequest extends IBillFormState {
  productTypeCode: string
  productTypeSwitchId: string
  identifierType?: string // identifierType

  quickCreditDisbursalYn?: string
  loanAcctNo?: string
  loanAmt?: string
}

export interface IBillPaymentPayResponse {
  acctCurJan: string // 현재 계좌 잔고
  acctNo: string
  custName: string // 고객명
  acctTitle: string // 계좌이름
  hisNo: string // Transaction History No
  customerId: string
  favorite: boolean // 즐겨찾기 여부
  fee: string // 결제 이체 수수료(현 시점에서는 당행 송금으로 처리하여 항상 0으로 반환)
  paidAmount: string // 지불 금액
  paidDate: number // 지불 시각
  productTypeCode: string
  trxPayKey: number // 거래목록 Key
  refNo: string // transNo
  plnToken: string // plnToken
  tselSerialNum: string
  ticketInfo1?: string
  ticketInfo2?: string
  ticketInfo3?: string
  loanAcctNo?: string
  loanAmt?: string
  loanBalance?: string // Loan total used credit
  creditLimit?: string // Available Credit
  disbursalDate?: number // Loan disbursal date-time
  identifierType?: string
  plnMeterNo?: string
  plnTariff?: string
  plnMaterai?: string
  plnPpn?: string
  plnPbjtTl?: string
  plnAngsuran?: string
  plnRpStroomToken?: string
  plnJmlhKwh?: string
  plnFooter?: string
  plnBlTh?: string
  plnStndMtr?: string
  plnOutStnd?: string
  plnRefNo?: string
}

export interface IBillPaymentAddFavoriteRequest {
  trxPayKey: number // trxPayKey
}

export interface IBillPaymentRemoveFavoriteRequest {
  trxPayKey: number // trxPayKey
}

export interface IBillPaymentRemoveRecentRequest {
  trxPayKey: number // trxPayKey
}

export interface IProductType {
  identifierName: string
  identifierType: string
  redoYn: string
  code: string
  name: string
  switchId: string
  isAutoFilled: boolean // Auto-Filled 여부
  voucherList: string[]
  transactionFee: string // 수수료
  appsBillType: string // af.send billtype 값
  qcPayable: boolean // Quick Credit 결제 가능 여부
}

export interface IProductGroupType {
  code: string
  name: string
  initial: string
  color: string
  productTypeList: IProductType[]
}

export interface IPaymentType {
  code: string
  name: string
  productGroupList: IProductGroupType[]
}

export interface IBillPaymentRecentAndFavorite {
  acctNo: string // 지불 계좌번호
  customerId: string // 고객번호
  favorite: boolean // 최근 목록 중 즐겨찾기 등록한 거래인지 여부
  lastUpdatedDate: number // 최종 변경 일자
  productTypeCode: string // ProductType’s code
  productTypeName: string // ProductType’s name
  productTypeSwitchId: string // ProductType’s switchId
  trxPayKey: number // 거래목록 Key
  redoYn?: string // redoYn
}

export interface IBillPaymentMainRequest {
  rowCnt: number // 조회할 즐겨찾기 목록의 사이즈
}

export interface IBillPaymentGetCodeResponse {
  paymentTypeList: IPaymentType[]
}

export interface IBillPaymentMainResponse extends IBillPaymentGetCodeResponse {
  favoriteList: IBillPaymentRecentAndFavorite[]
  recentlyList: IBillPaymentRecentAndFavorite[]
  minDisbursalAmount: string // 대출 가능 최소 금액
}

export interface IBillPaymentGetPulsaProductGroupCodeByPhoneNoRequest {
  phoneNo: string
}

export interface IBillPaymentGetPulsaProductGroupCodeByPhoneNoResponse {
  productGroupTypeCode: string
}

export const isBillPaymentTransactionFailedCode = (code: STATUS_CODE): boolean =>
  8100 <= code && code <= 8199 // 81xx
